import React, { memo } from 'react';
import './actionButton.scss';
import Button from 'b2b-ui-components-lib/lib/components/button';
import iconDownload from '../../assests/svg/icon-download.svg';
import iconEdit from '../../assests/svg/icon-edit.svg';

type Props = {
  downloadHandler: Function;
  isLoading: boolean;
};
export const ActionButton = memo(({ downloadHandler = () => {}, isLoading }: Props) => {
  return (
    <div className="action_area">
      <Button buttonClass="download_button" variant="outlinebtn" onClick={downloadHandler} disabled={isLoading}>
        <img src={iconDownload} alt="Download" /> Download Rate Card {isLoading && <span className="loading_icon"></span>}
      </Button>
      {/* <Button variant="outlinebtn">
        <img src={iconEdit} alt="Download" /> Edit Rate Card
      </Button> */}
    </div>
  );
});
